import showCard from "./show_card/show_card";
import worksList from "./works_list/works_list";

export default {
  show_card: showCard,
  tech_map: worksList,
};
